import './DistanceComponent.css'

import toGoImage from '../../../assets/to_go3.png'
import { useRef } from "react";

interface IDistanceComponent {
    distance: number | null
}

export default function DistanceComponent(props: IDistanceComponent) {
    const canvasRef = useRef<HTMLCanvasElement>(null)
    const canvas = canvasRef.current
    if(canvas !== null && props.distance !== null) {
        const context = canvas.getContext('2d')
        context!.fillStyle = '#ffffff'
        context!.fillRect(0, 0, context!.canvas.width, context!.canvas.height)
        const myImage = new Image();
        myImage.src = toGoImage

        myImage.onload = function() {
            canvas.width = myImage.width;
            canvas.height = myImage.height;
            const x = 35;
            const y = 47;
            context!.drawImage(myImage,0,0);
            context!.font = "22px Verdana";
            context!.fillStyle = "#ffffff";
            context!.fillText(props.distance!.toFixed(1),x,y);
        }
    }


    console.log('distance rendered')
    return (
        <>
            <canvas className={'canvas'} ref={canvasRef}/>
        </>

    )
}